import React, { useState, useEffect } from 'react'
import ReviewsListCards from '../../common/Reviews_Cards/list'
import Tab from "apollo-react/components/Tab";
import Tabs from "apollo-react/components/Tabs";
import Badge from "apollo-react/components/Badge";
import useMyCommitteeReviews from '../../../hooks/useMyCommitteeReviews'

export default function CommitteeReviewsList() {
    const {
        pendingReviews,
        approvedReviews,
        rejectedReviews,
        pricingRequestsProgress,
        raRequestsProgress,
        summary,
        loading,
        error,
    } = useMyCommitteeReviews();

    useEffect(() => {
        const storedTab = localStorage.getItem("customer_reviews_activeTab");
        const tabIndex = storedTab !== null ? parseInt(storedTab, 10) : 0;
        setActiveTab(tabIndex);
    }, []);

    // const [activeTab, setActiveTab] = useState(0)
    const [activeTab, setActiveTab] = useState(() => {
    const storedTab = localStorage.getItem("customer_reviews_activeTab");
        return storedTab !== null ? parseInt(storedTab, 10) : 0;
    });
    // Optionally handle error state
    if (error) {
        return <div>Error loading assessment reviews.</div>
    }
    
    const handleTabChange = (event, value) => {
        setActiveTab(value)
        localStorage.setItem("customer_reviews_activeTab", value);
    }
    
    // Handle completion of reviews - refresh data if needed
    const handleComplete = async () => {
        // Note: useMyCommitteeReviews hook should handle data refresh automatically
        // If manual refresh is needed, you can call a refetch function here
    }
    
    const getCurrentData = () => {
        switch (activeTab) {
            case 0:
                return pendingReviews
            case 1:
                return approvedReviews
            case 2:
                return rejectedReviews
            case 3:
                return pricingRequestsProgress
            case 4:
                return raRequestsProgress
            default:
                return pendingReviews
        }
    }
    
    const getRoute = () => {
        // For pending reviews tab, use the editable review route
        if (activeTab === 0) {
            return `/customer/assessment-review`
        }
        // For approved/rejected reviews tabs, use the read-only review details route
        return `/customer/assessment-review/review-details`
    }
    
    const getTabLabel = (tabIndex) => {
        switch (tabIndex) {
            case 0: return 'pending'
            case 1: return 'approved'
            case 2: return 'rejected'
            case 3: return 'pricing'
            case 4: return 'Committee'
            default: return 'pending'
        }
    }
    
    if (loading) {
        return <div>Loading assessment reviews...</div>
    }
    
    const currentData = getCurrentData()
    
    return (
        <div>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                truncate
                style={{ marginBottom: "30px" }}
                shape="box"
            >
                <Tab
                    label={
                        <>
                            Pending Action
                            <Badge badgeContent={summary.pending_count} />
                        </>
                    }
                />
                <Tab
                    label={
                        <>
                            Approved
                            <Badge badgeContent={summary.approved_count} />
                        </>
                    }
                />
                <Tab
                    label={
                        <>
                            Rejected
                            <Badge badgeContent={summary.rejected_count} />
                        </>
                    }
                />
                <Tab
                    label={
                        <>
                            Pricing
                            <Badge badgeContent={summary.pricing_count} />
                        </>
                    }
                />
                <Tab
                    label={
                        <>
                            Committee
                            <Badge badgeContent={summary.ra_count} />
                        </>
                    }
                />
            </Tabs>
            
            {/* {currentData?.length === 0 ? (
                <div>
                    No {getTabLabel(activeTab)} assessment reviews available.
                </div>
            ) : ( */}
                <ReviewsListCards 
                    requestsProgresses={currentData} 
                    route={getRoute()}
                    onComplete={handleComplete}
                    persona={"committee"}
                    currentTab={activeTab}
                />
            {/* )} */}
        </div>
    )
}
